import React, { createContext, useContext } from 'react';
import {
  TUserJWTPayload,
  useAuthenticatedUser,
} from '../hooks/use-authenticated-user.hook';

export type TUserContext = {
  user?: TUserJWTPayload;
  logout: () => void;
  isAdmin: boolean;
  hasMultipleAgencies: boolean;
};

export const UserContext = createContext<TUserContext | null>(null);

export const UserContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const userContextValues = useAuthenticatedUser();

  return (
    <UserContext.Provider value={userContextValues}>
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = (): TUserContext => {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error('useUserContext must be used within a UserContextProvider');
  }

  return context;
};
